import { CmsService } from './../../../services/cms.service';
import { ResourceService } from 'src/app/services/resource.service';
import { LoadingService } from './../../../services/loading.service';
import { ChangeDetectorRef, Component, OnInit, AfterViewChecked } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Dictionary } from 'src/app/models/IDictionary';

@Component({
  selector: 'layout-inner',
  templateUrl: './layout-inner.component.html',
  styleUrls: ['./layout-inner.component.css']
})
export class LayoutInnerComponent implements OnInit,AfterViewChecked {
  mySpinner;
  isViewLoading: boolean;
  viewLoader: Dictionary<any>;
  isExportableComponent: boolean;

  async wand() {
    this.mySpinner = "toolbar-faicon-dk fa fa-spinner fa-spin";
    await this.delay(7000);
    this.mySpinner = "toolbar-faicon-dk";
  }

  public delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  faSpinner = faSpinner;
  direction;
  dynamicCSSUrl;
  myTheme;
  themeID = 1;
  message: string;
  isLoading: boolean = false;
  server = "http://localhost:4200/"
  test = "assets/css/en.css"
  constructor(
    public sanitizer: DomSanitizer,
    private resourceService: ResourceService,
    private loadingService: LoadingService,
    private cd: ChangeDetectorRef,
    private cmsService: CmsService) { }

  url() {
    return this.sanitizer.bypassSecurityTrustUrl(this.server + this.test);
  }
  ngOnInit() {
    this.loadingService.loaderState.subscribe(res => {

      this.isLoading = res.show;
    })

    this.loadingService.viewLoader.subscribe(res => {

      this.viewLoader = res;

    })
    /*   this.loadingService.isLoading.subscribe(res => {
        this.isLoading = res;
        this.cd.markForCheck();
      }); */
    this.resourceService.styleDirection.subscribe(res => {

      this.cmsService.contentModel.subscribe(theme => {
        if (theme != null) {
          this.myTheme = theme.theme;
          this.themeID = this.myTheme.themeID;
        }


        if (res != null && this.direction == null) {
          this.direction = res;
          switch (res) {
            case "ltr":
              ;
              if (this.themeID == 1) {
                this.dynamicCSSUrl = 'assets/css/en.css';
                this.disable('arStyleSheet');
                this.enable('enStyleSheet');
                this.disable('ar1StyleSheet');
                this.disable('en1StyleSheet');
                this.disable('ar2StyleSheet');
                this.disable('en2StyleSheet');

              } else {
                if (this.themeID == 2) {
                  this.dynamicCSSUrl = 'assets/css/en1.css';
                  this.disable('arStyleSheet');
                  this.disable('enStyleSheet');
                  this.disable('ar1StyleSheet');
                  this.enable('en1StyleSheet');
                  this.disable('ar2StyleSheet');
                  this.disable('en2StyleSheet');
                } else {
                  this.dynamicCSSUrl = 'assets/css/en2.css';
                  this.disable('arStyleSheet');
                  this.disable('enStyleSheet');
                  this.disable('ar1StyleSheet');
                  this.disable('en1StyleSheet');
                  this.disable('ar2StyleSheet');
                  this.enable('en2StyleSheet')
                }
              }

              break
            case "rtl":
              if (this.themeID == 1) {
                this.dynamicCSSUrl = 'assets/css/ar.css';
                this.enable('arStyleSheet');
                this.disable('enStyleSheet');
                this.disable('ar1StyleSheet');
                this.disable('en1StyleSheet');
                this.disable('ar2StyleSheet');
                this.disable('en2StyleSheet');

              } else {
                if (this.themeID === 2) {
                  this.dynamicCSSUrl = 'assets/css/ar1.css';
                  this.disable('arStyleSheet');
                  this.disable('enStyleSheet');
                  this.enable('ar1StyleSheet');
                  this.disable('en1StyleSheet');
                  this.disable('ar2StyleSheet');
                  this.disable('en2StyleSheet');
                } else {
                  this.dynamicCSSUrl = 'assets/css/ar2.css';
                  this.disable('arStyleSheet');
                  this.disable('enStyleSheet');
                  this.disable('ar1StyleSheet');
                  this.disable('en1StyleSheet');
                  this.enable('ar2StyleSheet');
                  this.disable('en2StyleSheet')
                }
              }
              break;
          }
        }
      })



    })

    this.resourceService.isExportableComponent.subscribe(res=>{
      this.isExportableComponent=res;
    })


  }


  ngAfterViewChecked(){
    //your code to update the model
    this.cd.detectChanges();
 }

  get anyViewLoaderEnable() {
    if (this.viewLoader != null) {
      for (let key in this.viewLoader) {
        let value = this.viewLoader[key];
        if (value) {
          return true;
        }
        // Use `key` and `value`
      }
    }
    return false;
  }
  disable(cssId) {
    (document.getElementById(cssId) as any).disabled = true;
  }
  enable(cssId) {
    (document.getElementById(cssId) as any).disabled = false;
  }

}

